<div class="card incidencia-seguridad-ticket-modal revision-mensual-seguridad-modal">
  <div class="card-header card-header-primary">
    <div class="row">
      <div class="col-sm-12 col-md-11">
        <h4 class="card-title"><b>Revisión mensual</b></h4>
        <p class="card-category">Incidencias de seguridad - {{ periodoCapitalizado || "Periodo anterior" }}</p>
      </div>
      <div class="col-sm-12 col-md-1 text-right">
        <button type="button" mat-icon-button aria-label="Cerrar" (click)="cerrar()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="wraper">
      <div class="container">
        <div class="alert alert-danger revision-mensual-seguridad-modal__alert" *ngIf="error">
          <i class="material-icons">error_outline</i>
          <span>{{ error }}</span>
        </div>

        <section class="revision-mensual-seguridad-modal__section">
          <div class="revision-mensual-seguridad-modal__summary">
            <div>
              <span>Periodo revisado</span>
              <strong>{{ periodoCapitalizado || "-" }}</strong>
            </div>
          </div>

          <mat-form-field appearance="outline" class="w-100 revision-mensual-seguridad-modal__comment">
            <mat-label>Comentario</mat-label>
            <textarea matInput aria-label="Comentario" rows="4" maxlength="500" [(ngModel)]="comentario" name="comentarioRevision"
              [readonly]="!!revisionActual" required
              placeholder="Registra la anotación de la revisión mensual"></textarea>
          </mat-form-field>
        </section>

        <div mat-dialog-actions class="justify-content-end revision-mensual-seguridad-modal__actions">
          <button type="button" mat-button class="btn btn-default" (click)="cerrar()">Cerrar</button>
          <button type="button" mat-button class="btn btn-success" (click)="guardar()" [disabled]="!puedeGuardar">
            {{ guardando ? "Guardando..." : "Guardar revisión" }}
            <i class="material-icons">save</i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
